/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

/**
 * Request schema for validating a zipcode
 */
export interface ZipcodeValidationRequest {
  /** ZIP code to validate */
  zip_code: string;
  /** State abbreviation */
  state: string;
}
